<!-- =========================================================================================
    File Name: Profile.vue
    Description: Profile Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div id="analyze-app">
    <vx-card :title="'Sale Performance ~ Last '+ activeTimeline.days +' days'" class="mb-base">
      <template slot="actions">
        <div class="btn-group">
          <vs-button 
            radius
            type="line"
            v-for="tl in timeline"
            :key="tl.days"
            @click="timelineLookup(tl)" 
            size="small" :color="tl.selected ? colors.primary : '#aaa'"
            >
            {{tl.label}}
          </vs-button>
        </div>
      </template>
    <!-- <pre>{{artefact.res.trend.current}}</pre> -->
    <!-- <vs-alert active="true" :color="colors.note" class="mb-3" icon-pack="feather" icon="icon-alert-triangle">
      <strong>Sale Performance</strong> ~ Last {{activeTimeline.days}} days
    </vs-alert> -->
    <!-- Current Month Stats -->
    <!-- <vx-card title="Sale Performance ~ Month Till Date" class="mb-base"> -->
      <div class="vx-row">
        <div class="vx-col w-full">
          <!-- <vx-card title="Current month sales" card-background="primary" title-color="#fff"> -->
          <!-- <vx-card title="Sale Performance - Month Till Date"> -->
          <!-- <vs-alert active="true" class="mb-base" icon-pack="feather" icon="icon-star">
            Chupa chups topping bonbon. Jelly-o toffee I love. Sweet I love wafer I love wafer.
          </vs-alert>-->
          <div class="vx-col w-full">
            <div class="vx-row">
              <div class="vx-col w-full md:w-1/4 lg:w-1/4 xl:w-1/4">
                <statistics-card-line
                  icon="DollarSignIcon"
                  :statistic="dashboard.overall[0].basket_value | numFormat('$ 0,0.00')"
                  statisticTitle="Dollar Sales / Checkout"
                  :chartData="statChartData"
                  color="success"
                  hideChart
                  icon-right
                  class="mb-2"
                ></statistics-card-line>
              </div>

              <div class="vx-col w-full md:w-1/4 lg:w-1/4 xl:w-1/4">
                <statistics-card-line
                  icon="BoxIcon"
                  :statistic="dashboard.overall[0].basket_size"
                  statisticTitle="Unit Sales / Checkout"
                  :chartData="statChartData"
                  color="primary"
                  hideChart
                  icon-right
                  class="mb-2"
                ></statistics-card-line>
              </div>

              <div class="vx-col w-full md:w-1/4 lg:w-1/4 xl:w-1/4">
                <statistics-card-line
                  icon="ShoppingBagIcon"
                  :statistic="Math.round(dashboard.overall[0].cost_to_company) | numFormat('$ 0,0')"
                  statisticTitle="PO Value"
                  :chartData="statChartData"
                  color="danger"
                  hideChart
                  icon-right
                  class="mb-2"
                ></statistics-card-line>
              </div>

              <div class="vx-col w-full md:w-1/4 lg:w-1/4 xl:w-1/4">
                <statistics-card-line
                  icon="TruckIcon"
                  :statistic="dashboard.overall[0].inventory | numFormat"
                  statisticTitle="Current Inventory"
                  :chartData="statChartData"
                  color="danger"
                  hideChart
                  icon-right
                  class="mb-2"
                ></statistics-card-line>
              </div>
            </div>
          </div>
          <div class="vx-col w-full">
            <div class="vx-row">

              <div class="vx-col w-full md:w-1/4 lg:w-1/4 xl:w-1/4">
                <statistics-card-line
                  icon="DollarSignIcon"
                  :statistic="Math.round(dashboard.overall[0].retail_price) | numFormat('$ 0,0')"
                  statisticTitle="Dollar Sales"
                  :chartData="statChartData"
                  color="success"
                  hideChart
                  icon-right
                  class="mb-2"
                ></statistics-card-line>
              </div>

              <div class="vx-col w-full md:w-1/4 lg:w-1/4 xl:w-1/4">
                <statistics-card-line
                  icon="PackageIcon"
                  :statistic="dashboard.overall[0].items | numFormat"
                  statisticTitle="Unit Sales"
                  :chartData="statChartData"
                  color="primary"
                  hideChart
                  icon-right
                  class="mb-2"
                ></statistics-card-line>
              </div>

              <div class="vx-col w-full md:w-1/4 lg:w-1/4 xl:w-1/4">
                <statistics-card-line
                  icon="LayersIcon"
                  :statistic="dashboard.overall[0].checkouts | numFormat"
                  statisticTitle="Checkouts"
                  :chartData="statChartData"
                  color="primary"
                  hideChart
                  icon-right
                  class="mb-2"
                ></statistics-card-line>
              </div>

              <div class="vx-col w-full md:w-1/4 lg:w-1/4 xl:w-1/4">
                <statistics-card-line
                  icon="DollarSignIcon"
                  :statistic="Math.round(dashboard.overall[0].cost_to_company) | numFormat('$ 0,0')"
                  statisticTitle="Cost to Company"
                  :chartData="statChartData"
                  color="danger"
                  hideChart
                  icon-right
                  class="mb-2"
                ></statistics-card-line>
              </div>

            </div>
          </div>
          <!-- </vx-card> -->
        </div>
      </div>
    <!-- </vx-card> -->

    <!-- Trend Stats -->
    <vs-alert active="true" :color="colors.note" class="mb-3 mt-base" icon-pack="feather" icon="icon-activity">
      <strong>Sale Trend</strong> ~ Last {{activeTimeline.days}} days
    </vs-alert>

    <!-- <vx-card title="Sale Trend" subtitle="~ Last 90 days"> -->
      <!-- <vs-alert
        active="true"
        :color="colors.note"
        class="mb-2"
        icon-pack="feather"
        icon="icon-activity"
      >~ Last 90 days</vs-alert> -->
      <div class="vx-row">
        <div class="vx-col w-full md:w-1/3 lg:w-1/3 mb-2">
          <vx-card title="Dollar Sales / Checkout">
            <template slot="actions">
              <!-- <feather-icon icon="SettingsIcon" svgClasses="w-6 h-6 text-grey"></feather-icon> -->
            </template>
            <div slot="no-body" class="p-6 pb-0">
              <vue-apex-charts
                type="line"
                height="266"
                :options="trendLineRPO.chartOptions"
                :series="buildSeriesData('basket_value', 'Dollar Sales / Checkout')"
              />
            </div>
          </vx-card>
        </div>
        <div class="vx-col w-full md:w-1/3 lg:w-1/3 mb-2">
          <vx-card title="Unit Sales / Checkout">
            <template slot="actions">
              <!-- <feather-icon icon="SettingsIcon" svgClasses="w-6 h-6 text-grey"></feather-icon> -->
            </template>
            <div slot="no-body" class="p-6 pb-0">
              <vue-apex-charts
                type="line"
                height="266"
                :options="trendLineUPO.chartOptions"
                :series="buildSeriesData('basket_size', 'Unit Sales / Checkout')"
              />
            </div>
          </vx-card>
        </div>
        <div class="vx-col w-full md:w-1/3 lg:w-1/3 mb-2">
          <vx-card title="Basket Size">
            <template slot="actions">
              <!-- <feather-icon icon="SettingsIcon" svgClasses="w-6 h-6 text-grey"></feather-icon> -->
            </template>
            <div slot="no-body" class="p-6 pb-0">
              <vue-apex-charts
                type="line"
                height="266"
                :options="trendLineInventory.chartOptions"
                :series="buildSeriesData('inventory', 'Basket Size')"
              />
            </div>
          </vx-card>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full md:w-1/3 lg:w-1/3 mb-2">
          <vx-card title="Dollar Sales">
            <template slot="actions">
              <!-- <feather-icon icon="SettingsIcon" svgClasses="w-6 h-6 text-grey"></feather-icon> -->
            </template>
            <div slot="no-body" class="p-6 pb-0">
              <vue-apex-charts
                type="line"
                height="266"
                :options="trendLineRev.chartOptions"
                :series="buildSeriesData('retail_price', 'Dollar Sales')"
              />
            </div>
          </vx-card>
        </div>
        <div class="vx-col w-full md:w-1/3 lg:w-1/3 mb-2">
          <vx-card title="Unit Sales">
            <template slot="actions">
              <!-- <feather-icon icon="SettingsIcon" svgClasses="w-6 h-6 text-grey"></feather-icon> -->
            </template>
            <div slot="no-body" class="p-6 pb-0">
              <vue-apex-charts
                type="line"
                height="266"
                :options="trendLineQty.chartOptions"
                :series="buildSeriesData('items', 'Unit Sales')"
              />
            </div>
          </vx-card>
        </div>
        <div class="vx-col w-full md:w-1/3 lg:w-1/3 mb-2">
          <vx-card title="Checkouts">
            <template slot="actions">
              <!-- <feather-icon icon="SettingsIcon" svgClasses="w-6 h-6 text-grey"></feather-icon> -->
            </template>
            <div slot="no-body" class="p-6 pb-0">
              <vue-apex-charts
                type="line"
                height="266"
                :options="trendLineTrans.chartOptions"
                :series="buildSeriesData('checkouts', 'Checkouts')"
              />
            </div>
          </vx-card>
        </div>
      </div>
    <!-- </vx-card> -->
    </vx-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import VueApexCharts from "vue-apexcharts";
import StatisticsCardLine from "@/app/shared/components/statistics-cards/StatisticsCardLine.vue";

import { appCommons } from '@/app/shared/services';
import appConfig from "@/../appConfig.js";

import { actionsTypes } from "../shared/state";

const themeColors = appConfig.chart.colors;

export default {
  data() {
    return {
      isNavOpen: false,
      type: "all",
      activeSearch: null,
      filterReset: true,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.7
      },
      wasSidebarOpen: null,
      colors: appConfig.colors,
      timeline: [{
        label: "7 d",
        days: 7,
        selected: false
      }, {
        label: "15 d",
        days: 15,
        selected: false
      }, {
        label: "30 d",
        days: 30,
        selected: true
      }, {
        label: "90 d",
        days: 90,
        selected: false
      }, {
        label: "180 d",
        days: 180,
        selected: false
      }, {
        label: "1 y",
        days: 365,
        selected: false
      }],
      activeTimeline: {
        label: "30 d",
        days: 30,
        selected: true
      },
      payload: {
        tags: [],
        dateRange: appCommons.allowedDateScope('', 30, '', ''),
        query: "",
        mode: "",
        type: "DASH",
        res: {}
      },
      isLoading: false,
      statChartData: {},
      trendLineRPO: {
        series: [
          {
            name: "",
            data: []
          }
        ],        
        chartOptions: {
          chart: {
            type: "area",
            toolbar: { show: false },
            dropShadow: {
              enabled: true,
              top: 20,
              left: 2,
              blur: 6,
              opacity: 0.2
            }
          },
          stroke: {
            curve: "smooth",
            dashArray: [0, 8],
            width: [2, 2]
          },
          grid: {
            borderColor: "#ebebeb"
          },
          legend: {
            show: false
          },
          colors: themeColors,
          fill: {
            type: "gradient",
            gradient: {
              shade: "dark",
              inverseColors: false,
              gradientToColors: themeColors,
              shadeIntensity: 1,
              type: "horizontal",
              opacityFrom: 1,
              opacityTo: 1,
              stops: [0, 100, 100, 100]
            }
          },
          markers: {
            size: 0,
            hover: {
              size: 5
            }
          },
          xaxis: {
            type: "datetime",
            tickAmount: 2,
            title: {
              text: "Week",
              offsetY: 10
            },
            labels: {
              hideOverlappingLabels: true,
              // datetimeFormatter: {
              //   year: 'yyyy',
              //   month: 'MMM \'yy',
              //   day: 'dd MMM',
              //   hour: 'HH:mm'
              // },
              style: {
                cssClass: "text-grey fill-current"
              }
            },
            axisTicks: {
              show: false
            },
            // categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'July', 'Aug', 'Sep'],
            axisBorder: {
              show: false
            }
          },
          yaxis: {
            tickAmount: 5,
            labels: {
              style: {
                cssClass: "text-grey fill-current"
              },
              formatter: function(val) {
                return val > 999 || val < -999 ? (val / 1000).toFixed(1) + "k" : val.toFixed(2);
              }
            },
            title: {
              text: "Revenue ( " + this.$options.filters.currencySymbol("") + " )",
              rotate: 90,
              offsetY: 0,
              offsetX: 0,
              style: { fontSize: "11px", cssClass: "" }
            }
          },
          tooltip: {
            x: { show: false }
          }
        }
      },
      trendLineUPO: {
        series: [
          {
            name: "",
            data: []
          }
        ],        
        chartOptions: {
          chart: {
            type: "area",
            toolbar: { show: false },
            dropShadow: {
              enabled: true,
              top: 20,
              left: 2,
              blur: 6,
              opacity: 0.2
            }
          },
          stroke: {
            curve: "smooth",
            dashArray: [0, 8],
            width: [2, 2]
          },
          grid: {
            borderColor: "#ebebeb"
          },
          legend: {
            show: false
          },
          colors: themeColors,
          fill: {
            type: "gradient",
            gradient: {
              shade: "dark",
              inverseColors: false,
              gradientToColors: themeColors,
              shadeIntensity: 1,
              type: "horizontal",
              opacityFrom: 1,
              opacityTo: 1,
              stops: [0, 100, 100, 100]
            }
          },
          markers: {
            size: 0,
            hover: {
              size: 5
            }
          },
          xaxis: {
            type: "datetime",
            tickAmount: 2,
            title: {
              text: "Week",
              offsetY: 10
            },
            labels: {
              hideOverlappingLabels: true,
              // datetimeFormatter: {
              //   year: 'yyyy',
              //   month: 'MMM \'yy',
              //   day: 'dd MMM',
              //   hour: 'HH:mm'
              // },
              style: {
                cssClass: "text-grey fill-current"
              }
            },
            axisTicks: {
              show: false
            },
            // categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'July', 'Aug', 'Sep'],
            axisBorder: {
              show: false
            }
          },
          yaxis: {
            tickAmount: 5,
            labels: {
              style: {
                cssClass: "text-grey fill-current"
              },
              formatter: function(val) {
                return val > 999 || val < -999 ? (val / 1000).toFixed(1) + "k" : val.toFixed(2);
              }
            },
            title: {
              text: "# Units",
              rotate: 90,
              offsetY: 0,
              offsetX: 0,
              style: { fontSize: "11px", cssClass: "" }
            }
          },
          tooltip: {
            x: { show: false }
          }
        }
      },
      trendLineInventory: {
        series: [
          {
            name: "",
            data: []
          }
        ],        
        chartOptions: {
          chart: {
            type: "area",
            toolbar: { show: false },
            dropShadow: {
              enabled: true,
              top: 20,
              left: 2,
              blur: 6,
              opacity: 0.2
            }
          },
          stroke: {
            curve: "smooth",
            dashArray: [0, 8],
            width: [2, 2]
          },
          grid: {
            borderColor: "#ebebeb"
          },
          legend: {
            show: false
          },
          colors: themeColors,
          fill: {
            type: "gradient",
            gradient: {
              shade: "dark",
              inverseColors: false,
              gradientToColors: themeColors,
              shadeIntensity: 1,
              type: "horizontal",
              opacityFrom: 1,
              opacityTo: 1,
              stops: [0, 100, 100, 100]
            }
          },
          markers: {
            size: 0,
            hover: {
              size: 5
            }
          },
          xaxis: {
            type: "datetime",
            tickAmount: 2,
            title: {
              text: "Week",
              offsetY: 10
            },
            labels: {
              hideOverlappingLabels: true,
              // datetimeFormatter: {
              //   year: 'yyyy',
              //   month: 'MMM \'yy',
              //   day: 'dd MMM',
              //   hour: 'HH:mm'
              // },
              style: {
                cssClass: "text-grey fill-current"
              }
            },
            axisTicks: {
              show: false
            },
            // categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'July', 'Aug', 'Sep'],
            axisBorder: {
              show: false
            }
          },
          yaxis: {
            tickAmount: 5,
            labels: {
              style: {
                cssClass: "text-grey fill-current"
              },
              formatter: function(val) {
                return val > 999 || val < -999 ? (val / 1000).toFixed(1) + "k" : val.toFixed(2);
              }
            },
            title: {
              text: "# Units (Avg.)",
              rotate: 90,
              offsetY: 0,
              offsetX: 0,
              style: { fontSize: "11px", cssClass: "" }
            }
          },
          tooltip: {
            x: { show: false }
          }
        }
      },
      trendLineQty: {
        series: [
          {
            name: "",
            data: []
          }
        ],        
        chartOptions: {
          chart: {
            type: "area",
            toolbar: { show: false },
            dropShadow: {
              enabled: true,
              top: 20,
              left: 2,
              blur: 6,
              opacity: 0.2
            }
          },
          stroke: {
            curve: "smooth",
            dashArray: [0, 8],
            width: [2, 2]
          },
          grid: {
            borderColor: "#ebebeb"
          },
          legend: {
            show: false
          },
          colors: themeColors,
          fill: {
            type: "gradient",
            gradient: {
              shade: "dark",
              inverseColors: false,
              gradientToColors: themeColors,
              shadeIntensity: 1,
              type: "horizontal",
              opacityFrom: 1,
              opacityTo: 1,
              stops: [0, 100, 100, 100]
            }
          },
          markers: {
            size: 0,
            hover: {
              size: 5
            }
          },
          xaxis: {
            type: "datetime",
            tickAmount: 2,
            title: {
              text: "Week",
              offsetY: 10
            },
            labels: {
              hideOverlappingLabels: true,
              // datetimeFormatter: {
              //   year: 'yyyy',
              //   month: 'MMM \'yy',
              //   day: 'dd MMM',
              //   hour: 'HH:mm'
              // },
              style: {
                cssClass: "text-grey fill-current"
              }
            },
            axisTicks: {
              show: false
            },
            // categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'July', 'Aug', 'Sep'],
            axisBorder: {
              show: false
            }
          },
          yaxis: {
            tickAmount: 5,
            labels: {
              style: {
                cssClass: "text-grey fill-current"
              },
              formatter: function(val) {
                return val > 999 || val < -999 ? (val / 1000).toFixed(1) + "k" : val.toFixed(2);
              }
            },
            title: {
              text: "# Units",
              rotate: 90,
              offsetY: 0,
              offsetX: 0,
              style: { fontSize: "11px", cssClass: "" }
            }
          },
          tooltip: {
            x: { show: false }
          }
        }
      },
      trendLineRev: {
        series: [
          {
            name: "",
            data: []
          }
        ],        
        chartOptions: {
          chart: {
            type: "area",
            toolbar: { show: false },
            dropShadow: {
              enabled: true,
              top: 20,
              left: 2,
              blur: 6,
              opacity: 0.2
            }
          },
          stroke: {
            curve: "smooth",
            dashArray: [0, 8],
            width: [2, 2]
          },
          grid: {
            borderColor: "#ebebeb"
          },
          legend: {
            show: false
          },
          colors: themeColors,
          fill: {
            type: "gradient",
            gradient: {
              shade: "dark",
              inverseColors: false,
              gradientToColors: themeColors,
              shadeIntensity: 1,
              type: "horizontal",
              opacityFrom: 1,
              opacityTo: 1,
              stops: [0, 100, 100, 100]
            }
          },
          markers: {
            size: 0,
            hover: {
              size: 5
            }
          },
          xaxis: {
            type: "datetime",
            tickAmount: 2,
            title: {
              text: "Week",
              offsetY: 10
            },
            labels: {
              hideOverlappingLabels: true,
              // datetimeFormatter: {
              //   year: 'yyyy',
              //   month: 'MMM \'yy',
              //   day: 'dd MMM',
              //   hour: 'HH:mm'
              // },
              style: {
                cssClass: "text-grey fill-current"
              }
            },
            axisTicks: {
              show: false
            },
            // categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'July', 'Aug', 'Sep'],
            axisBorder: {
              show: false
            }
          },
          yaxis: {
            tickAmount: 5,
            labels: {
              style: {
                cssClass: "text-grey fill-current"
              },
              formatter: function(val) {
                return val > 999 || val < -999 ? (val / 1000).toFixed(1) + "k" : val.toFixed(2);
              }
            },
            title: {
              text:
                "Revenue ( " + this.$options.filters.currencySymbol("") + " )",
              rotate: 90,
              offsetY: 0,
              offsetX: 0,
              style: { fontSize: "11px", cssClass: "" }
            }
          },
          tooltip: {
            x: { show: false }
          }
        }
      },
      trendLineTrans: {
        series: [
          {
            name: "",
            data: []
          }
        ],        
        chartOptions: {
          chart: {
            type: "area",
            toolbar: { show: false },
            dropShadow: {
              enabled: true,
              top: 20,
              left: 2,
              blur: 6,
              opacity: 0.2
            }
          },
          stroke: {
            curve: "smooth",
            dashArray: [0, 8],
            width: [2, 2]
          },
          grid: {
            borderColor: "#ebebeb"
          },
          legend: {
            show: false
          },
          colors: themeColors,
          fill: {
            type: "gradient",
            gradient: {
              shade: "dark",
              inverseColors: false,
              gradientToColors: themeColors,
              shadeIntensity: 1,
              type: "horizontal",
              opacityFrom: 1,
              opacityTo: 1,
              stops: [0, 100, 100, 100]
            }
          },
          markers: {
            size: 0,
            hover: {
              size: 5
            }
          },
          xaxis: {
            type: "datetime",
            tickAmount: 2,
            title: {
              text: "Week",
              offsetY: 10
            },
            labels: {
              hideOverlappingLabels: true,
              // datetimeFormatter: {
              //   year: 'yyyy',
              //   month: 'MMM \'yy',
              //   day: 'dd MMM',
              //   hour: 'HH:mm'
              // },
              style: {
                cssClass: "text-grey fill-current"
              }
            },
            axisTicks: {
              show: false
            },
            // categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'July', 'Aug', 'Sep'],
            axisBorder: {
              show: false
            }
          },
          yaxis: {
            tickAmount: 5,
            labels: {
              style: {
                cssClass: "text-grey fill-current"
              },
              formatter: function(val) {
                return val > 999 || val < -999 ? (val / 1000).toFixed(1) + "k" : val.toFixed(2);
              }
            },
            title: {
              text: "# Transactions",
              rotate: 90,
              offsetY: 0,
              offsetX: 0,
              style: { fontSize: "11px", cssClass: "" }
            }
          },
          tooltip: {
            x: { show: false }
          }
        }
      }
    };
  },
  methods: {
    init() {
      this.$vs.loading({
        // background: this.backgroundLoading,
        // color: this.colorLoading,
        // container: "#analyze-app",
        // scale: 0.45,
        type: "radius"
      });
      
      this.payload.dateRange = appCommons.allowedDateScope('', this.activeTimeline.days, '', '');

      this.$store.dispatch(
        "analyze/" + actionsTypes.FETCH_ANALYZE_ARTEFACT,
        this.payload
      );
    },
    timelineLookup(tl) {
      for(var t of this.timeline) {
        if(t.days === tl.days) {
          t.selected = true;
          this.activeTimeline = t;
        } else {
          t.selected = false;
        }
      }
      this.init();
    },
    buildSeriesData(type, name) {
      let series = [];

      let filteredUnitDataTrend = [
        {
          name: name,
          data: []
        }
      ];

      let filteredActual = this.filterAndSortData(
        this.dashboard.trend,
        type
      );

      let maxWeeksActual = this.dashboard && this.dashboard.trend ? this.dashboard.trend.length : 0;//appCommons.countOfUnitsBetweenDates('week', this.payload.dateRange.startDate, this.payload.dateRange.endDate);

      filteredUnitDataTrend.data = this.buildseriesOfGroup(type, maxWeeksActual, filteredActual, filteredActual[0].sale_year);

      series.push(filteredUnitDataTrend);

      return series;
    },
    filterAndSortData(data, type) {

      let filteredData = [];
      Object.assign(filteredData, data);

      return filteredData.sort(function(t1, t2) {
        var year1 = t1.sale_year;
        var year2 = t2.sale_year;

        var week1 = t1.sale_week;
        var week2 = t2.sale_week;

        if (year1 < year2 && week1 < week2) {
          return -1;
        }
        if (year1 > year2 && week1 > week2) {
          return 1;
        }

        // tags must be equal
        return 0;
      });
    },    
    buildseriesOfGroup(type, maxWeeks, groupedUnit, startYear) {
      let series = [];
      let weekIndex = 0;
      let currentWeek = 1;
      let currentMonth = 0;
      let currentYear = startYear;
      let prevWeek = 100;

      while (weekIndex < maxWeeks) {
        if (groupedUnit[weekIndex]) {
          currentWeek = Number(groupedUnit[weekIndex].sale_week || 1);
          currentMonth = Number(groupedUnit[weekIndex].sale_month || 0);
          currentYear = groupedUnit[weekIndex].sale_year;

          //   let x = "w" + currentWeek + (prevWeek > currentWeek ? " '" + currentYear : "");
          let x = this.$moment()
            .isoWeekYear(currentYear)
            .isoWeek(currentWeek+1)
            .startOf('isoWeek')
            .format('MM-DD-YYYY');

          // let x =
          //   "w" +
          //   currentWeek +
          //   (prevWeek > currentWeek ? " '" + currentYear : "");
          let y = groupedUnit[weekIndex][type]
            ? groupedUnit[weekIndex][type] : 0;

          series.push({
            x: x,
            y: this.$options.filters.numFormat(y, '0.00')
          });
        } else {
          let x = this.$moment()
            .isoWeekYear(currentWeek === 1 ? ++currentYear : currentYear)
            .isoWeek(currentWeek+1)
            .startOf('isoWeek')
            .format('MM-DD-YYYY');

          // let x =
          //   "w" +
          //   currentWeek +
          //   (prevWeek > currentWeek ? " '" + ++currentYear : "");
          let y = "0.00";

          currentWeek = currentWeek + 1;

          series.push({
            x: x,
            y: y
          });
        }

        prevWeek = currentWeek;
        weekIndex++;
      }
      return series;
    },        
  },
  computed: {
    dashboard() {
      return this.artefact && this.artefact.res  ? this.artefact.res : {};
    },
    ...mapGetters({ artefact: "analyze/artefact" })
  },
  mounted() {
    this.wasSidebarOpen = this.$store.state.reduceButton;
    this.$store.commit("TOGGLE_REDUCE_BUTTON", true);
    this.init();
    this.filterReset = true;

    this.$store.watch(
      (state, getters) => getters["analyze/isLoading"],
      (newValue, oldValue) => {
        this.isLoading = newValue;
        if (this.isLoading) {
          this.$vs.loading({
            // background: this.backgroundLoading,
            // color: this.colorLoading,
            // container: "#analyze-app",
            // scale: 0.45,
            type: "radius"
          });
        }

        if (!this.isLoading) {
          this.$vs.loading.close();
          // this.$vs.loading.close("#analyze-app > .con-vs-loading");
        }
      }
    );
  },
  beforeDestroy() {
    if (!this.wasSidebarOpen) this.$store.commit("TOGGLE_REDUCE_BUTTON", false);
  },
  watch: {
    "$store.state.AppScopeTrack"(val) {
      this.init();
    }
  },
  components: {
    VueApexCharts,
    StatisticsCardLine
  }
};
</script>

<style lang="scss">
#analyze-app {
  .greet-user {
    position: relative;
    .decore-left {
      position: absolute;
      left: 0;
      top: 0;
    }
    .decore-right {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  @media (max-width: 576px) {
    .decore-left,
    .decore-right {
      width: 140px;
    }
  }
}
</style>
